export const iconFontAwesomeHumanitarianPersonRays = (
	<i className="fa-solid fa-person-rays"></i>
);
